import { render, staticRenderFns } from "./CaseReviewReportView.vue?vue&type=template&id=2e4c6c8d&scoped=true&"
import script from "./CaseReviewReportView.vue?vue&type=script&lang=js&"
export * from "./CaseReviewReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c6c8d",
  null
  
)

export default component.exports